export default __webpack_public_path__ + "static/media/burger_menu.af8960af.svg";